export default "__VITE_ASSET__Bq1i4cva__"